import React from "react";
import './ProductCategories.css'; // Renamed CSS file

import { Heading, Category } from "../../../components";
import { productsContent } from "../../../constants"; // Changed from cars to products
import { getProductCategories } from "../../../utils"; // Changed from getPopularCarCategories



const ProductCategories = () => { // Renamed component

  // Get the Product Categories
  const categories = getProductCategories(productsContent); // Changed function call

  // Show all categories (removed the top 5 slicing)
  const allCategories = categories; // Or just use categories directly

  return (

    <section className="categories">

      {/* Section Heading - Updated text */}
      <Heading title={'Explore Our Categories'} subTitle={'Template Categories'} />

      {/* Category Items */}
      <div className="box-container">

        {/* Map over all categories array to render each category */}
        {allCategories.map(({ index, category, count, image }) => (
          <Category
            key={index}
            index={index}
            category={category}
            count={count}
            image={image}
          />
        ))}

      </div>

    </section>

  );
};

export default ProductCategories;